module.exports = __webpack_public_path__ + "static/media/DownArrow.f14ad87a.svg";